const DIVIDER = 'border-[rgba(0,0,0,0.12)]';
const SHADOW =
  'shadow-[0px_3px_1px_-2px_rgba(0,0,0,0.2),0px_2px_2px_0px_rgba(0,0,0,0.14),0px_1px_5px_0px_rgba(0,0,0,0.12)]';

const classes = {
  // Outer "Carrier Alerts" card
  card: 'bg-white border border-[#e5e7eb] rounded-[12px] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.08)] p-2 flex flex-col gap-4',
  headingRow: 'flex gap-3 items-start',
  headingTextCol: 'flex flex-col gap-0.5 min-w-0',
  headingTitle:
    'text-[16px] leading-[1.75] font-normal text-[#123b50] tracking-[0.15px]',
  summary:
    'text-[14px] leading-[1.43] text-[rgba(0,0,0,0.6)] tracking-[0.17px]',

  // Collapsible "System Alerts" section (header + content in one bordered box)
  section:
    'rounded-[8px] border border-[rgba(2,110,161,0.5)] bg-[rgba(2,110,161,0.08)] flex flex-col overflow-hidden',
  sectionHeader: 'flex gap-3 items-center px-4 py-3 cursor-pointer select-none',
  sectionTitle:
    'text-[14px] font-medium text-[#123b50] tracking-[0.1px] whitespace-nowrap',
  pillsWrap: 'flex gap-2 items-center',
  // Chip supplies the pill shape + background; force the inner label white.
  pillText:
    '[&_.chip-label]:text-white! [&_.chip-label]:text-[12px]! [&_.chip-label]:font-medium! [&_.chip-label]:leading-5! [&_.chip-label]:tracking-[0.14px]!',
  chevron: 'ml-auto shrink-0 text-[#123b50] transition-transform duration-200',
  content:
    'bg-white border-t border-[rgba(2,110,161,0.5)] p-3 flex flex-col gap-3',

  // Severity cards
  noticeCard: `rounded-[8px] border border-[#468db5] bg-[#e5f6fd] p-3 flex flex-col gap-2 ${SHADOW}`,
  blockCard: `rounded-[8px] border border-[#b00020] bg-[#fdeded] p-3 flex flex-col gap-2 ${SHADOW}`,
  warningCard: `rounded-[8px] border border-[#ff8f00] bg-[#fff4e5] p-3 flex flex-col gap-2 ${SHADOW}`,
  noticeCardTitle:
    'flex gap-2 items-center text-[14px] font-medium text-[#026ea1] tracking-[0.15px]',
  blockCardTitle:
    'flex gap-2 items-center text-[14px] font-medium text-[#b00020] tracking-[0.15px]',
  warningCardTitle:
    'flex gap-2 items-center text-[14px] font-medium text-[#ff8f00] tracking-[0.15px]',

  // Rows
  rowsWrap: `border-t ${DIVIDER}`,
  rowDivider: `border-t ${DIVIDER}`,
  row: 'flex items-start justify-between gap-3 py-2',
  rowTitle:
    'text-[14px] font-medium text-[#b00020] tracking-[0.15px] leading-[1.5]',
  rowText:
    'text-[14px] leading-[1.43] text-[rgba(0,0,0,0.87)] tracking-[0.17px]',
};

export default classes;
